export interface User {
    id?: number;
    password?: string;
    name?: string;
    email?: string;
    status?: string;
    rememberMe?: boolean;
  }
  
  
  export enum LocalStorageKeys {
    Token = 'token',
    Email='email',
    UserData = 'userData',
    JwtToken = 'jwtToken',
    Username = 'username',
    RememberMe = 'rememberMe',
    Is_fb_connected = 'is_fb_connected',
    Is_fb_business_connected = 'is_fb_business_connected',
    Is_insta_connected = 'is_insta_connected',
    Is_twitter_connected = 'is_twitter_connected',
    Is_connected = 'is_connected',
    Password = 'password',
    firstName = 'firstName',
    lastName = 'lastName',
    Role = 'role',
    FbAccType = 'fbAccType',
    FbUserId = 'fbUserId',
    LinkedInUserName = 'linkedInUserName',
    FacebookInUserName = 'facebookInUserName',
    FacebookBusinessUserName = 'facebookBusinessUserName',
    InstaUserName = 'instaUserName',
    TwitterUserName = 'twitterUserName'
  }